/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/LoadingSingleScreen',['pixi', 'absolute', 'lodash', 'absolute/stringmanager', 'Managers/ScaleManager', 'Solitaire/SolitaireGameMode'],

    function (PIXI, Absolute, _, _s, ScaleManager, SolitaireGameMode) {

        var LoadingSingleScreen = function (ui, game) {
            this.ui = ui;
            this.game = game;
            this.gameMode = (this.game.config.singleGame.mode);
            this.initLoadingSingleScreen(ui);
        };

        LoadingSingleScreen.prototype = Object.create(Absolute.Screen.prototype);

        LoadingSingleScreen.prototype.initLoadingSingleScreen = function (ui) {

            Absolute.Screen.call(this);

            this.ui = ui;

            var resClass = Absolute.ScreenMetrics.getResClass();
            var canvas = this.ui.container.children[2];
            this.initForceScaleSprite();
            this.bgIsLoaded = false;
            if (!this.bgIsLoaded) {
                if (canvas) {
                    var image = new Image();
                    image.onload = function () {
                        canvas.style.backgroundImage = 'url(' + image.src + ')';
                        canvas.className += ' ' + 'main-canvas';
                        canvas.style.backgroundSize = 'cover';
                        this.bgIsLoaded = true;

                        this.gameLabel = new PIXI.Text(_s('headings.' + this.gameMode), {
                            font: Absolute.ScreenMetrics.getResScale() * 100 + "px Arial",
                            fontFamily: 'segoe',
                            align: 'center',
                            fill: '#ffffff',
                            dropShadow: true,
                            dropShadowColor: '#000000',
                            dropShadowDistance: 5
                        });
                        this.gameLabel.anchor.set(0.5, 0.5);
                        this.gameLabel.position.set(Absolute.Coords.x(960), Absolute.Coords.y(240));
                        this.addChild(this.gameLabel);
                        this.tile = PIXI.Sprite.fromFrame(this.gameMode.toLowerCase() + '/tile.png');
                        this.tile.anchor.set(0.5, 0.5);
                        this.addChild(this.tile);
                        this.tile.position.set(Absolute.Coords.x(960), Absolute.Coords.y(540));
                        this.bar = PIXI.Sprite.fromFrame('bar.png');
                        this.addChild(this.bar);
                        this.bar.anchor.set(0.5, 0.5);
                        this.bar.position.set(this.tile.x + Absolute.Coords.x(5), this.tile.y + Absolute.Coords.y(240));
                        this.fill = PIXI.Sprite.fromFrame(this.gameMode.toLowerCase() + '/fill.png');
                        this.addChild(this.fill);
                        this.fill.anchor.set(0.5, 0.5);
                        this.fill.position.set(this.bar.x, this.bar.y);
                        this.maskOfFill = new PIXI.Graphics();
                        this.maskOfFill.position.set(this.fill.x - this.fill.width / 2, this.fill.y - this.fill.height / 2);
                        this.maskOfFill.beginFill(0x33ff00, 0.7);
                        this.maskOfFill.drawRect(0, 0, this.fill.width, this.fill.height);
                        this.maskOfFill.endFill();
                        this.addChild(this.maskOfFill);
                        this.fill.mask = this.maskOfFill;
                        this.maskOfFill.scale.x = 0;
                        this.handleResize();
                    }.bind(this);
                    image.src = './spritesheets/' + resClass + '/menu_bg.jpg';
                }
            }

            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
        };

        LoadingSingleScreen.prototype.show = function (isSplash) {
            this.visible = true;
        };

        LoadingSingleScreen.prototype.hide = function () {
            this.visible = false;
        };

        LoadingSingleScreen.prototype.updateLoadingProgress = function (percent, doFast) {
            if (!this.bgIsLoaded) return;
            if (this.loadIsDone) return;
            var mask = this.maskOfFill;
            if (this.scaleTween) this.scaleTween.stop();
            this.scaleTween = new TWEEN.Tween({x: this.maskOfFill.scale.x})
                .to({x: percent}, doFast ? 500 : 2000)
                .easing(TWEEN.Easing.Quadratic.In)
                .onUpdate(function () {
                    mask.scale.x = this.x;
                })
                .onComplete(function () {
                    this.scaleTween = null;
                }.bind(this))
                .start();
        };

        LoadingSingleScreen.prototype.resetLoadingProgress = function () {
            if (!this.bgIsLoaded) return;
            this.maskOfFill.scale.x = 0;
            this.loadIsDone = false;
        };

        LoadingSingleScreen.prototype.finishLoadingProgress = function () {
            if (!this.bgIsLoaded) return;
            this.updateLoadingProgress(1, true);
            this.loadIsDone = true;
        };

        LoadingSingleScreen.prototype.onShow = function () {
            Absolute.Screen.prototype.onShow.call(this);
        };

        LoadingSingleScreen.prototype.onHide = function () {
            Absolute.Screen.prototype.onHide.call(this);
        };

        LoadingSingleScreen.prototype.initForceScaleSprite = function () {
            var tempGraphics = new PIXI.Graphics();
            tempGraphics.beginFill(0xff0000, .3);
            tempGraphics.drawRect(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
            tempGraphics.endFill();
            this.forceScaleSprite = new PIXI.Sprite(tempGraphics.generateTexture());
            this.forceOffsetX = Absolute.Coords.x(0);
            this.forceOffsetY = Absolute.Coords.y(0);
            this.forceScaleSprite.alpha = 0;
            this.addChild(this.forceScaleSprite);
        };

        LoadingSingleScreen.prototype.handleResize = function () {
            if (!this.bgIsLoaded) return;
            if (this.parent) this.updateTransform();
            var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
            this.scale.set(1, 1);
            var initialWidth = this.width, initialHeight = this.height;
            this.scale.set(oldScaleX, oldScaleY);
            var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
                screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
                roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
            this.width = initialWidth * screenScaleX;
            this.height = initialHeight * screenScaleY;
            var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
            var widthToShow = initialWidth, heightToShow = initialHeight;
            var tookCare = false;
            if (realWidth > roomWidth) {
                this.width = Absolute.Coords.x(1920);
                var delta = roomWidth / widthToShow;
                this.height = ((initialHeight * screenScaleY) * delta);
                if ((this.height / screenScaleY) > roomHeight) {
                    this.height = Absolute.Coords.y(1080);
                    var delta = roomHeight / heightToShow;
                    this.width = ((initialWidth * screenScaleX) * delta);
                }
                tookCare = true;
            }
            if (!tookCare && (realHeight > roomHeight)) {
                this.height = Absolute.Coords.y(1080);
                var delta = roomHeight / heightToShow;
                this.width = ((initialWidth * screenScaleX) * delta);
                if ((this.width / screenScaleX) > roomWidth) {
                    this.width = Absolute.Coords.x(1920);
                    var delta = roomWidth / widthToShow;
                    this.height = ((initialHeight * screenScaleY) * delta);
                }
            }
            this.x = (Absolute.Coords.x(1920) * .5) - (this.width / 2) + this.forceOffsetX;
            this.y = (Absolute.Coords.y(1080) * .5) - (this.height / 2) + this.forceOffsetY;
        };

        return LoadingSingleScreen;
    });

